var cannotLoadAjax = "Can not process your request";
var innovaApiUrl = $("#InnovaApiUrl").val();
var innovaApiKey = $("#InnovaKey").val();
var defaultKeyword = "Enter your product question or search term";

$(document).ready(function () {
  $('#keyword').keydown(function (event) {
    if (event.keyCode == 13) {
      searchFAQs();
      $('#keyword').focus();
    }
  });

});

function searchFAQs() {
  var keyword = $("#keyword").val();
  if (keyword == defaultKeyword) {
    keyword = "";
  }

  $('#ModalContentAjax').modal("show");
  var totalPage = 0;
  var requestData = 'keyword=' + keyword;
  xhr = $.ajax({
    url: innovaApiUrl + '/supports/search-faqs',
    cache: false,
    crossOrigin: true,
    type: 'post',
    data: requestData,
    beforeSend: function (xhr) {
      xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
    },
    error: function () {
      $('#ModalContentAjax').modal("hide");
      alert(cannotLoadAjax);
    },
    success: function (result) {
      if(result.message.success){
        $('#support-wrapper').html(result.faqResult);            
      }
      $('#ModalContentAjax').modal("hide");      

    }
  });

}
